import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/[lng]/(blog)/blog/error.tsx");
